import React from 'react';
import {
  getAIAnalysisDescriptionFromLevel,
  getAIIsFalsePositiveFromLevel,
  getFlattenedResults,
} from '../../../Utils/TestResultsMethods';
import { get } from '../../../Utils/helpers';
import { CopyToClipboard } from '../../UI/CopyToClipboard/CopyToClipboard';

export const UrlTestSuite = {
  getTitle: (tr) => {
    const app = get(tr, 'context.application');
    const client = get(tr, 'context.client');
    const t = get(tr, 'context.template');
    const se = get(tr, 'context.siteEdition');
    const url = get(tr, 'url');
    return [`(${app || ''}) ${client}`, t, se, url].join(' > ');
  },

  getExtraActions: (tr) => (
    <div className='d-flex' style={{ padding: '0' }}>
      <CopyToClipboard text={tr.name} />
      <span
        className='e-icons e-open-link mt-2'
        onClick={(e) => window.open(tr.name, '_blank', 'noopener,noreferrer')}
      />
    </div>
  ),

  getIT: (tr) => get(tr, 'it', getFlattenedResults(tr)),

  getStatus: (tr) => get(tr, 'status', get(tr, 'testResults.status')),

  getTypeText: () => 'Urls',

  getTransformedData: (tr) => {
    const f = {
      ...tr,
      it: getFlattenedResults(tr),
      name: tr.url,
    };
    delete f.flattenedResults;
    delete f.flattenedResultsAIReviewed;
    return f;
  },

  getExtraData: (tr) => ({
    context: tr.context,
    url: tr.url,
  }),

  getName: (tr) => get(tr, 'url'),

  getContentMessage: (tr) =>
    get(tr, 'flattenedResults.extraInfo.error.message'),

  getAIAnalysisDescription: (tr) => getAIAnalysisDescriptionFromLevel(tr),
  getAIIsFalsePositive: (tr) => getAIIsFalsePositiveFromLevel(tr),
};
